import LeadResultType from "./LeadResultType";

const missingExceptionMessage = (propName: string) => `Failed to provide required configured value '${propName}'.`;
const parseExceptionMessage = (propName: string) => `Failed to parse or find required configured value '${propName}'.`;

const appName = process.env.REACT_APP_ENVNAME || null;
const appVersionNumber = process.env.REACT_APP_VERSION_NO;
if (!appVersionNumber) throw missingExceptionMessage("REACT_APP_VERSION_NO");

const aspireBaseApiUrl = process.env.REACT_APP_ASPIRE_GEM_URL;
if (!aspireBaseApiUrl) throw missingExceptionMessage("REACT_APP_ASPIRE_GEM_URL");

const a1cUpperLimit = Number(process.env.REACT_APP_DISQUAL_A1C_LIMIT);
if (isNaN(a1cUpperLimit)) throw parseExceptionMessage("REACT_APP_DISQUAL_A1C_LIMIT");

const bmiLowerLimit = Number(process.env.REACT_APP_DISQUAL_BMI_LOWER_LIMIT);
if (isNaN(bmiLowerLimit)) throw parseExceptionMessage("REACT_APP_DISQUAL_BMI_LOWER_LIMIT");

const bmiUpperLimit = Number(process.env.REACT_APP_DISQUAL_BMI_UPPER_LIMIT);
if (isNaN(bmiUpperLimit)) throw parseExceptionMessage("REACT_APP_DISQUAL_BMI_UPPER_LIMIT");

const leadResultBadLead = Number(process.env.REACT_APP_LEAD_RESULT_ID_BAD_LEAD);
if (isNaN(leadResultBadLead)) throw parseExceptionMessage("REACT_APP_LEAD_RESULT_ID_BAD_LEAD");
const leadResultBooked = Number(process.env.REACT_APP_LEAD_RESULT_ID_BOOKED);
if (isNaN(leadResultBooked)) throw parseExceptionMessage("REACT_APP_LEAD_RESULT_ID_BOOKED");
const leadResultDoNotCall = Number(process.env.REACT_APP_LEAD_RESULT_ID_DO_NOT_CALL);
if (isNaN(leadResultDoNotCall)) throw parseExceptionMessage("REACT_APP_LEAD_RESULT_ID_DO_NOT_CALL");
const leadResultExistingPatient = Number(process.env.REACT_APP_LEAD_RESULT_ID_EXISTING_PATIENT);
if (isNaN(leadResultExistingPatient)) throw parseExceptionMessage("REACT_APP_LEAD_RESULT_ID_EXISTING_PATIENT");
const leadResultNotReached = Number(process.env.REACT_APP_LEAD_RESULT_ID_NOT_REACHED);
if (isNaN(leadResultNotReached)) throw parseExceptionMessage("REACT_APP_LEAD_RESULT_ID_NOT_REACHED");
const leadResultOtherProcedures = Number(process.env.REACT_APP_LEAD_RESULT_ID_OTHER_PROCEDURES);
if (isNaN(leadResultOtherProcedures)) throw parseExceptionMessage("REACT_APP_LEAD_RESULT_ID_OTHER_PROCEDURES");
const leadResultMedicalEscalation = Number(process.env.REACT_APP_LEAD_RESULT_ID_MEDICAL_ESCALATION);
if (isNaN(leadResultMedicalEscalation)) throw parseExceptionMessage("REACT_APP_LEAD_RESULT_ID_MEDICAL_ESCALATION");
const leadResultDroppedChat = Number(process.env.REACT_APP_LEAD_RESULT_ID_DROPPED_CHAT);
if (isNaN(leadResultDroppedChat)) throw parseExceptionMessage("REACT_APP_LEAD_RESULT_ID_DROPPED_CHAT");

const bodyBusinessUnitId = process.env.REACT_APP_BODY_BUSINESS_UNIT_ID;
if (!bodyBusinessUnitId) throw missingExceptionMessage("REACT_APP_BODY_BUSINESS_UNIT_ID");
const contourBusinessUnitId = process.env.REACT_APP_CONTOUR_BUSINESS_UNIT_ID;
if (!contourBusinessUnitId) throw missingExceptionMessage("REACT_APP_CONTOUR_BUSINESS_UNIT_ID");

/** A mapping from a lead result type to its configured id. */
const leadResultIds: Record<LeadResultType, number> = {
  [LeadResultType.BadLead]: leadResultBadLead,
  [LeadResultType.Booked]: leadResultBooked,
  [LeadResultType.ExistingPatient]: leadResultExistingPatient,
  [LeadResultType.OtherProcedures]: leadResultOtherProcedures,
  [LeadResultType.NotReached]: leadResultNotReached,
  [LeadResultType.MedicalEscalation]: leadResultMedicalEscalation,
  [LeadResultType.DoNotCall]: leadResultDoNotCall,
  [LeadResultType.DroppedChat]: leadResultDroppedChat
};

const inContactOAuthClientId = process.env.REACT_APP_OAUTH_INCONTACT_CLIENT_ID;
if (!inContactOAuthClientId) throw missingExceptionMessage("REACT_APP_OAUTH_INCONTACT_CLIENT_ID");
const inContactOAuthUrl = process.env.REACT_APP_OAUTH_INCONTACT_URL;
if (!inContactOAuthUrl) throw missingExceptionMessage("REACT_APP_OAUTH_INCONTACT_URL");
const zenotiOAuthClientId = process.env.REACT_APP_OAUTH_ZENOTI_CLIENT_ID;
if (!zenotiOAuthClientId) throw missingExceptionMessage("REACT_APP_OAUTH_ZENOTI_CLIENT_ID");
const zenotiOAuthUrl = process.env.REACT_APP_OAUTH_ZENOTI_URL;
if (!zenotiOAuthUrl) throw missingExceptionMessage("REACT_APP_OAUTH_ZENOTI_URL");
const oauthRedirectPath = process.env.REACT_APP_OAUTH_REDIRECT;
if (!oauthRedirectPath) throw missingExceptionMessage("REACT_APP_OAUTH_REDIRECT");

const EnvironmentConfiguration = {
  a1cUpperLimit,
  apiBaseUrl: aspireBaseApiUrl,
  app: {
    name: appName,
    version: appVersionNumber
  },
  bmi: {
    lowerLimit: bmiLowerLimit,
    upperLimit: bmiUpperLimit
  },
  leadResultIds,
  businessUnitIds: {
    body: bodyBusinessUnitId.toLowerCase(),
    contour: contourBusinessUnitId.toLowerCase()
  },
  oauth: {
    zenoti: {
      url: zenotiOAuthUrl,
      clientId: zenotiOAuthClientId
    },
    inContact: {
      url: inContactOAuthUrl,
      clientId: inContactOAuthClientId
    },
    redirectPath: oauthRedirectPath
  }
};

export default EnvironmentConfiguration;
